import { call } from '../../utils/serviceUtils';
import {
  AUTHORIZATION_GET,
  ROLE_GET,
  AUTHORIZATION
  } from '../../config/paths';


export function getAuthorizations() {
  return call.get(AUTHORIZATION_GET,
    {

    });
}

export function getRoles() {
  return call.get(ROLE_GET,
    {

    });
}

export function deleteAuthorizationById(id) {
  return call.delete(AUTHORIZATION+'/'+id,
  {
    
  });
}

export function createAuthorization(data) {
  return call.post(AUTHORIZATION,data);
}

export function updateAuthorization(id,data) {
  return call.put(AUTHORIZATION+'/'+id,data);
}


